import { IUserMilestone } from '../../IUserMilestone';

/**
 * Retailer has seen warehouse sale promo modal *
 */
export const HAS_SEEN_WAREHOUSE_SALE_MODAL_NOV_22 =
  'HAS_SEEN_WAREHOUSE_SALE_MODAL_NOV_22' as IUserMilestone.RetailerMilestone;
